<footer class="abc-premium-footer">
  <div class="abc-footer-container">
    <div class="abc-footer-main-row">
      <!-- LEFT SECTION: Brand & Socials -->
      <div class="abc-footer-brand-column">
        <a href="/" class="abc-logo-link">
          <img
            src="assets/images/abc-logo.svg"
            alt="ABC Talkies"
            class="abc-footer-logo"
          />
        </a>

        <p class="brand-tagline">World's First Cinema Marketplace</p>

        <div class="abc-social-area">
          <!-- 1. Instagram -->
          <a
            href="https://www.instagram.com/abctalkies/"
            target="_blank"
            class="social-icon insta"
            aria-label="Instagram"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-instagram"
            >
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
          </a>
          <!-- 2. Facebook -->
          <a
            href="https://www.facebook.com/abctalkies/"
            target="_blank"
            class="social-icon fb"
            aria-label="Facebook"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="feather feather-facebook"
            >
              <path
                d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
              ></path>
            </svg>
          </a>
          <!-- 3. X (Twitter) -->
          <a
            href="https://x.com/AbcTalkies"
            target="_blank"
            class="social-icon x"
            aria-label="X (Twitter)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="feather feather-x"
            >
              <path
                d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"
              ></path>
            </svg>
          </a>
        </div>
      </div>

      <!-- RIGHT SECTION: Links Grid -->
      <div class="abc-footer-links-grid">
        <!-- Column 1: Company -->
        <div class="footer-col">
          <h4 class="col-title">COMPANY</h4>
          <ul class="footer-links">
            <li>
              <a href="{{ abcStaticLink }}/about-us/" target="_blank"
                >About Us</a
              >
            </li>
            <li>
              <a href="{{ abcStaticLink }}/contact-us/" target="_blank"
                >Contact Us</a
              >
            </li>
          </ul>
        </div>

        <!-- Column 2: Legal -->
        <div class="footer-col">
          <h4 class="col-title">LEGAL</h4>
          <ul class="footer-links">
            <li>
              <a
                href="{{
                  filmfactoryStaticLink
                }}/wp-content/uploads/2025/10/2.-ABC-Film-Factory-Privacy-Policy.pdf"
                target="_blank"
                >Privacy Policy</a
              >
            </li>
            <li>
              <a
                href="{{
                  filmfactoryStaticLink
                }}/wp-content/uploads/2025/10/1.-ABC-Film-Factory-Terms-of-Use-policy.pdf"
                target="_blank"
                >Terms of Use</a
              >
            </li>
            <li>
              <a routerLink="/static/copyright-policy">Copyright Policy</a>
            </li>
            <li>
              <a [routerLink]="['/static/cookies-policy']">Cookies Policy</a>
            </li>
          </ul>
        </div>

        <!-- Column 3: Support -->
        <div class="footer-col">
          <h4 class="col-title">SUPPORT</h4>
          <ul class="footer-links">
            <li>
              <a routerLink="/static/payment-refund-policy">Refund Policy</a>
            </li>
            @if (this.bigShortService.isBigShortChallengeActive()) {
              <li>
                <a [href]="bigShortURL" target="_blank">Big Shorts Challenge</a>
              </li>
            }
          </ul>
        </div>

        <!-- Column 4: Apps -->
        <div class="footer-col apps-col">
          <h4 class="col-title">GET THE APP</h4>
          <div class="app-badges">
            <a
              href="https://play.google.com/store/apps/details?id=abctalkies.boxoffice.android"
              target="_blank"
              class="app-badge google"
            ></a>
            <a
              href="https://apps.apple.com/us/app/abc-talkies/id1586757822"
              target="_blank"
              class="app-badge apple"
            ></a>
          </div>
        </div>
      </div>
    </div>

    <!-- Copyright -->
    <div class="abc-footer-bottom">
      <p class="copyright-text">
        &copy; {{ date.getFullYear() }}
        {{ "iAMFilmmaker.ABC Talkies" | translate }}. All Rights Reserved.
      </p>
    </div>
  </div>
</footer>
